import { useQuery } from "@tanstack/react-query";
import { systemService } from "@/services/systemService";

export function useVersion() {
  return useQuery({ queryKey: ["system", "version"], queryFn: systemService.getVersion });
}

export function useBuildInfo() {
  return useQuery({ queryKey: ["system", "build"], queryFn: systemService.getBuildInfo });
}
